"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTAINS = void 0;
exports.CONTAINS = {
    alias: 'CONTEM',
    description: 'Verifica a presença de uma sequência de caracteres em uma outra sequência de caracteres e retorna a informação sobre a existência ou não dessa sequência.',
    arg_names: ['texto', 'texto_a_localizar'],
    args_description: [
        'A sequência de caracteres que contém a informação desejada',
        'A sequência de caracteres que você procura',
    ],
};
